import { NgModule } from '@angular/core';
// import { NgxCookieStorageComponent } from './ngx-cookie-storage.component';

@NgModule({
    imports: [
    ],
    declarations: [
        // NgxCookieStorageComponent
    ],
    exports: [
        // NgxCookieStorageComponent
    ]
})
export class NgxCookieStorageModule { }
